unit GiftAidValidationErrorMessages;

interface

uses
  System.SysUtils, System.Classes;

type
  TGiftAidValidationErrorMessages = class
  public
    /// <summary>
    /// Converts the CSV error string from TFullDonationRec.Error (semicolon-separated rows:
    /// FieldName,ErrorCode,Value,AutoFixed) into a short human-readable message for the user.
    /// </summary>
    class function CsvToShortMessage(const ACsvError: string): string;
    class function CsvRowToShortMessage(const ACsvRow: string): string;
  private
    class function CsvFieldErrorsToShortMessage(const ACsvFieldErrors: string): string;
  end;

implementation

{ TGiftAidValidationErrorMessages }

class function TGiftAidValidationErrorMessages.CsvFieldErrorsToShortMessage(const ACsvFieldErrors: string): string;
const
  // Map error codes (from GiftAid.Interfaces Validation_Errors) to short user-facing text
  ErrorCodeToText: array[0..8] of string = (
    'Valid',           // skip
    'is missing',
    'should be blank',
    'is too short',
    'is too long',
    'has invalid format',
    'is out of range',
    'cannot be zero',
    'possible duplicate'
  );
  ErrorCodes: array[0..8] of string = (
    'Valid', 'Blank', 'NotBlank', 'TooShort', 'TooLong',
    'Format', 'OutOfRange', 'AmountZero', 'Duplicate'
  );
  // Friendly field names for display (same index as FieldKeys)
  FieldToLabel: array[0..9] of string = (
    'Post code', 'First name', 'Last name', 'Address', 'Title',
    'Donation date', 'Amount', 'Donation ID', 'Donor ID', 'Sponsored'
  );
  FieldKeys: array[0..9] of string = (
    'PostCode', 'FirstName', 'Lastname', 'Address', 'Title',
    'PayDate', 'Amount', 'DonationId', 'DonorId', 'Sponsored'
  );
var
  lRows: TArray<string>;
  lParts: TArray<string>;
  lRow, lFieldName, lErrorCode, lPhrase, lLabel: string;
  lMsg: TStringList;
  j, k: Integer;
begin
  Result := '';
  if ACsvFieldErrors.Trim = '' then
    Exit;

  lMsg := TStringList.Create;
  try
    lRows := ACsvFieldErrors.Split([';']);
    for lRow in lRows do
    begin
      lParts := lRow.Trim.Split([',']);
      if Length(lParts) < 2 then
        Continue;
      lFieldName := lParts[0].Trim;
      lErrorCode := lParts[1].Trim;
      if SameText(lErrorCode, 'Valid') then
        Continue;

      lPhrase := '';
      for k := 0 to High(ErrorCodes) do
        if SameText(ErrorCodes[k], lErrorCode) then
        begin
          if k < Length(ErrorCodeToText) then
            lPhrase := ErrorCodeToText[k]
          else
            lPhrase := lErrorCode;
          Break;
        end;
      if lPhrase = '' then
        lPhrase := lErrorCode;

      lLabel := lFieldName;
      for j := 0 to High(FieldKeys) do
        if SameText(FieldKeys[j], lFieldName) and (j < Length(FieldToLabel)) then
        begin
          lLabel := FieldToLabel[j];
          Break;
        end;
      lMsg.Add(lLabel + ' ' + lPhrase);
    end;

    if lMsg.Count > 0 then
    begin
      Result := lMsg[0];
      for j := 1 to lMsg.Count - 1 do
        Result := Result + ' • ' + lMsg[j];
    end
  finally
    lMsg.Free;
  end;
end;

class function TGiftAidValidationErrorMessages.CsvToShortMessage(const ACsvError: string): string;
var
  lSegments: TArray<string>;
  lSegment, lPartMsg: string;
  I: Integer;
begin
  Result := '';
  if ACsvError.Trim = '' then
    Exit;

  lSegments := ACsvError.Split([' | ']);
  for I := 0 to High(lSegments) do
  begin
    lSegment := lSegments[I].Trim;
    if lSegment = '' then
      Continue;

    lPartMsg := CsvFieldErrorsToShortMessage(lSegment);
    if lPartMsg = '' then
      lPartMsg := lSegment;

    if Result = '' then
      Result := lPartMsg
    else
      Result := Result + ' • ' + lPartMsg;
  end;
end;

class function TGiftAidValidationErrorMessages.CsvRowToShortMessage(const ACsvRow: string): string;
begin
  Result := CsvFieldErrorsToShortMessage(ACsvRow);
  if Result = '' then
    Result := ACsvRow.Trim;
end;

end.
